import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const updatedBySchema = z.string({ invalid_type_error: ISchemaError.UPDATED_BY_INVALID_TYPE }).default("");
